import type { SearchToken } from '../types';

export const stringifySearchTokens = (searchTokens: SearchToken[]) => {
  if (!searchTokens.length) return;

  return searchTokens
    .map(token => {
      if (token.type === 'source') {
        return `in:${token.value}`;
      }

      if (token.type === 'filter') {
        return `filter:${token.value}`;
      }

      if (token.type === 'tag') {
        return `tag:${token.fullName}`;
      }

      return token.value;
    })
    .join(' ');
};
